<template>
  <div class="container">
    <!-- 顶部 -->
    <div class="top">
      <van-icon name="arrow-left" size="20" color="var(--text_color)" @click="$router.go(-1)" />
      <svg-icon class-name="svgs" icon-class="service" @click="goServe" />
    </div>
    <!-- 头像名称 -->
    <div class="userInfo">
      <div class="head" @click="$router.push({ name: 'Head' })">
        <img v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" />
        <img v-else src="@/assets/img/heard.png" />
      </div>
      <div class="uTxt">
        <div class="name"><span>{{ userInfo.memberName }}</span> </div>
        <div class="id">UID:{{ userInfo.memberId }}<svg-icon class-name="svgs" icon-class="copy" @click="onCopy(userInfo.memberId)" /></div>
        <div class="lable">
          <!-- 已认证未认证 -->
          <div class="cert" v-if="userInfo.authenticationStatus == '4'"><svg-icon class-name="svgs" icon-class="cert" />
            <span>{{ $t('user').authenticated }}</span>
          </div>
          <div class="ncert" v-else><svg-icon class-name="svgs" icon-class="cert" /> <span>{{ $t('user').Notcertifiedyet
              }}</span></div>
          <div class="vip">{{ $t('user').trustscore }}:
            <span>{{ userInfo.trustScore }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 功能列表 -->
    <div class="Info">
      <!-- 邀请好友 -->
      <div class="item" @click="$router.push({ name: 'Share' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="share" />
          <span>{{ $t('user').Invitefriends }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- VIP -->
      <!-- <div class="item">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="vip" />
          <span>VIP</span>
        </div>
        <div>
          <span>VIP0</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div> -->
      <!-- 活动中心 -->
      <div class="item" @click="$router.push({ name: 'Activity' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="activity" />
          <span>{{ $t('user').Activecenter }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
    </div>
    <div class="line"></div>
    <div class="Info">
      <!-- 初级认证 -->
      <div class="item" @click="$router.push({ name: 'Auth' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="auth_base" />
          <span>{{ $t('auth').base }}</span>
        </div>
        <div>
          <span v-if="userInfo.authenticationStatus == '2'||userInfo.authenticationStatus == '4'">{{ $t('user').Completedverification }}</span>
          <span v-else>{{ $t('user').Tobeverified }}</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 高级认证 -->
      <div class="item" @click="$router.push({ name: 'HighAuth' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="auth" />
          <span>{{ $t('auth').high }}</span>
        </div>
        <div>
          <span v-if="userInfo.authenticationStatus == '4'">{{ $t('user').Completedverification }}</span>
          <span v-else>{{ $t('user').Tobeverified }}</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 资产认证 -->
      <div class="item" @click="$router.push({ name: 'AssetAuth' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="authAsset" />
          <span>{{ $t('auth').AssetCertification }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 安全设置 -->
      <div class="item" @click="$router.push({ name: 'Safe' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="safe" />
          <span>{{ $t('user').SecuritySettings }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 模拟交易 -->
      <div class="item">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="simTrade" />
          <span>{{ $t('trade').simulatedTrading }}</span>
        </div>
        <van-switch v-model="isSim" active-color="var(--text_color)" inactive-color="var(--ntext_color)" size="15px" @change="changeSimTade" />
      </div>
    </div>
    <div class="line"></div>
    <div class="Info">
      <!-- 选择语言 -->
      <div class="item" @click="$router.push({ name: 'Lang' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="lang" />
          <span>{{ $t('user').Lang }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 切换皮肤 -->
      <div class="item" @click="changeTheme">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="dark" v-if="theme == 'dark'" />
          <svg-icon class-name="svgs" icon-class="light" v-else />
          <span>{{ $t('user').changeTheme }}</span>
        </div>
        <van-switch v-model="checked" active-color="var(--text_color)" inactive-color="var(--ntext_color)" size="15px" />
      </div>
      <!-- 帮助中心 -->
      <div class="item" @click="goServe">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="help" />
          <span>{{ $t('user').helpcenter }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
      <!-- 关于我们 -->
      <div class="item" @click="$router.push({ name: 'About' })">
        <div class="left">
          <svg-icon class-name="svgs" icon-class="about" />
          <span>{{ $t('user').Aboutus }}</span>
        </div>
        <van-icon name="arrow" size="13" color="var(--ntext_color)" />
      </div>
    </div>
    <!-- 退出 -->
    <div class="out" @click="Logout">{{ $t('user').out }}</div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import userApi from '@/api/user'
import PublicHeader from '@/components/publicHeader'
import { Token } from '@/utils/mm'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      baseUrl: window.baseURL,
      checked: localStorage.getItem('theme') == '',
      userInfo: {},
      theme: localStorage.getItem('theme'),//主题颜色
    }
  },
  mounted() {
    this.getMemberInfo()
  },
  computed: {
    isSim: {
      get() {
        return this.$store.state.isSim
      },
      set(value) {
        this.$store.commit('setSim', value)
      }
    }
  },
  methods: {
    // 切换模拟交易
    async changeSimTade() {
      if (this.$store.state.isSim)
        await userApi.initSimTrade()
    },
    // 客服
    async goServe() {
      // const res = await systemApi.getConfig()
      // location.href = res.systemSetting.serviceUrl
      const res = await userApi.getMemberInfo()
      const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
      location.href = 'chatlinkonline.html?metadata=' + encodedData
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
    // 更换主题颜色
    changeTheme() {
      var theme = this.theme == 'dark' ? '' : 'dark'
      localStorage.setItem('theme', theme)
      EventBus.$emit('theme', theme)
      this.theme = theme
      this.checked = localStorage.getItem('theme') == ''
    },
    //跳转隐私协议
    async goAgreement() {
      const res = await systemApi.getContentList({ type: '0' })
      this.$router.push({ name: 'Detail', query: { Name: this.$t('user').agreement, id: res.rows[0].contentLocalizationId } })
    },
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
    //退出登录
    Logout() {
      this.$dialog.confirm({
        title: this.$t('user').outmsg,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          Token.remove()
          this.$router.push({ name: 'Login' })
          EventBus.$emit('Logout')
        })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .top {
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    width: 100%;
    background: var(--background_color);
    z-index: 1000;

    .svgs {
      width: 22px;
      height: 22px;
      color: var(--text_color);
    }
  }

  .userInfo {
    padding: 60px 15px 15px 15px;
    display: flex;

    .head {
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }

    .uTxt {
      margin-left: 15px;
      width: 280px;

      .name {
        margin-top: 5px;
        font-weight: 900;
        font-size: 16px;
        color: var(--text_color);
        word-break: break-all;
      }

      .id {
        margin-top: 10px;
        font-size: 13px;
        color: var(--ntext_color);

        .svgs {
          width: 13px;
          height: 13px;
          color: var(--ntext_color);
          margin-left: 5px;
        }
      }

      .lable {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .cert {
          font-size: 13px;
          color: #2dbd84;
          display: flex;
          align-items: center;

          .svgs {
            width: 18px;
            height: 18px;
            color: #2dbd84;
            margin-right: 5px;
          }
        }

        .ncert {
          font-size: 13px;
          color: var(--ntext_color);
          display: flex;
          align-items: center;

          .svgs {
            width: 18px;
            height: 18px;
            color: var(--ntext_color);
            margin-right: 5px;
          }
        }

        .vip {
          margin-left: 10px;
          font-size: 13px;
          color: var(--ntext_color);
        }
      }
    }
  }

  .line {
    margin: 10px 15px;
    height: 1px;
    background: var(--info_color);
  }

  .Info {
    .item {
      padding: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .svgs {
        width: 21px;
        height: 21px;
        color: var(--text_color);
      }

      .left {
        display: flex;
        align-items: center;

        span {
          margin-left: 15px;
          font-size: 14px;
          font-weight: 700;
          color: var(--text_color);
        }
      }

      span {
        font-size: 12px;
        color: var(--ntext_color);
        margin-right: 10px;
      }
    }
  }

  .out {
    margin: 25px 0;
    text-align: center;
    font-size: 13px;
    color: var(--ntext_color);
  }
}
</style>
